/**
 * Per-category sub-region card per scope §6.1.5. Atlas Day 2 Phase 3.
 *
 * Surface (default): "ISG categorizes products across N taxonomy categories.
 * Per-category overrides currently sparse; future scope."
 *
 * Surface (N=0 per D3 lock (c) conditional render — eventual-existence framing):
 * "ISG has not yet configured category taxonomy."
 *
 * Click handler stub for Phase 3 (Phase 6 wires inspect navigation per B.3).
 */

import type { JSX } from 'react';
import { useNavigate } from 'react-router-dom';
import { FolderTree } from 'lucide-react';
import type { CategorySubstrate } from '../../../lib/atlas/perEntitySubstrate';

export interface PerCategoryCardProps {
  substrate: CategorySubstrate;
}

export default function PerCategoryCard({ substrate }: PerCategoryCardProps): JSX.Element {
  const navigate = useNavigate();
  const { total } = substrate;
  const isEmpty = total === 0;
  const surfaceLine = isEmpty
    ? 'ISG has not yet configured category taxonomy.'
    : `ISG categorizes products across ${total} taxonomy ${total === 1 ? 'category' : 'categories'}. Per-category overrides currently sparse; future scope.`;
  return (
    <button
      type="button"
      data-sub-region-id="per-category"
      onClick={() => navigate('/admin/engine-atlas/inspect/per-category')}
      className="w-full text-left border border-border-subtle bg-surface-0 rounded-md p-3 hover:border-accent transition-colors cursor-pointer"
    >
      <div className="flex items-start gap-2">
        <FolderTree size={16} className="text-ink-secondary flex-shrink-0 mt-0.5" />
        <div className="flex-1 min-w-0">
          <h3 className="text-sm font-semibold text-ink-bright">Per-category</h3>
          <p className="text-xs text-ink-secondary mt-1">{surfaceLine}</p>
        </div>
      </div>
    </button>
  );
}
